<script setup lang="ts">
// 页面配置
definePage({
  name: 'market-hold-list',
  meta: {
    title: '经纪商持股列表',
  },
})
</script>

<template>
  <FmPageLayout navbar back :navbar-border="false">
    <div class="bg-[#fff] p-l-7px p-r-7px">
      <div class="h-34px flex items-center justify-center text-15px">
        <div>长江证劵</div>
        <FmIcon name="tabler:chevron-down" class="text-17px" />
      </div>
    </div>
    <van-index-bar>
      <van-index-anchor index="A" />
      <van-cell title="ABN" />
      <van-cell title="ACU Securities" />
      <van-cell title="阿仕特朗" />

      <van-index-anchor index="B" />
      <van-cell title="BARBP" />
      <van-cell title="Barclays" />
      <van-cell title="BARCLAYS" />
    </van-index-bar>
  </FmPageLayout>
</template>

<style lang="scss" scoped>
.active {
  color: #fff;
  background: #3c78ff;
  border-color: #3c78ff !important;
}
</style>
